import { Loader } from "@dbn/omnichannel-design-system-g4p";
import { option } from "fp-ts";
import { pipe } from "fp-ts/function";
import { Option } from "fp-ts/Option";
import { ExistingClientAuthenticationMethod } from "../globalDomain";
import * as remoteData from "../RemoteData";
import { useQuery } from "../useAPI";
import * as loanApi from "../StandardLoan/api";
import { StandardLoanFlowType } from "../StandardLoan/domain";
import { SignatureType } from "../StandardLoan/api";
import { RuntimeLocaleKey, useFormatMessage } from "../intl";

type Props = {
  renderChild: (signatureType: Option<SignatureType>) => JSX.Element;
  defaultAuthenticationMethod: Option<ExistingClientAuthenticationMethod>;
  flowType: StandardLoanFlowType;
};

export const AuthMethodCalculateBySignatureType = (props: Props) => {
  const [getSignatureType] = useQuery(loanApi.getSignatureType);
  const formatMessage = useFormatMessage();

  return pipe(
    getSignatureType,
    remoteData.fold(
      () => (
        <Loader
          ariaLabelMessage={formatMessage(
            "generic.loading.alt" as RuntimeLocaleKey
          )}
        />
      ),
      () => props.renderChild(option.none),
      signature =>
        pipe(
          signature.signatureType,
          option.fold(
            () => props.renderChild(option.none),
            signatureType => props.renderChild(option.some(signatureType))
          )
        )
    )
  );
};
